import { EntitysSelectors } from "@shared/src/enums/EntitysSelectors";
import { EntitySelectorDto } from "../EntitySelectorDto";

export class FormEntitySelectorDto extends EntitySelectorDto {

	public static new(activeFilterKeys: Array<String>): FormEntitySelectorDto {
		let result: FormEntitySelectorDto = new FormEntitySelectorDto();
		result.loadData(EntitysSelectors.Form, "", activeFilterKeys, 0, false);
		return result;
	}

	public getUrlGoToMaintenance(): string {
		return "system/screensandforms/definitionform";
	}

	public getUrlBack(): string {
		return "/maintenance/form";
	}

}